import {
    Component
} from '@angular/core';
import { BaseComponent, LanguageService } from '@lmnop/angular-core';
import { IoCContainer } from '@lmnop/web-core';
import { TranslateService } from '@ngx-translate/core';
import {
    IAppSettings,
    AppIoCKeys,
    IAppIoCContainer
} from 'app-src';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
    template: '',
    selector: 'app-page-base',
})
export abstract class PageBase extends BaseComponent {

    constructor(
        protected override spinnerService: NgxSpinnerService,         
        protected translateService: TranslateService,
        protected override languageService: LanguageService
    ) {
        super(spinnerService, translateService, languageService);
        this.ioc = IoCContainer.get(AppIoCKeys.IAppIoCContainer);
        this.settings = this.ioc.settings;
    }

    protected ioc: IAppIoCContainer;
    protected settings: IAppSettings;
}
